import * as React from 'react';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Select from 'react-select';
import { Button, Col, Collapse, Form, Row, Container } from 'react-bootstrap';
import {
    deleteCampaign,
    listCampaignDetails,
    updateCampaign,
} from '../actions/campaignActions';
import { listTags } from '../actions/tagActions';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {
    CAMPAIGN_UPDATE_DETAILS_RESET,
    CAMPAIGN_DELETE_RESET, CAMPAIGN_UPDATE_SUCCESS,
} from '../constants/campaignConstants';
import { listPlayers } from '../actions/playerActions';
import { listMedia } from '../actions/mediaActions';
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import {MultiSelect} from "../components/MultiSelect";
import CreatableSelect from "react-select/creatable";

const CampaignScreen = ({ match, history, language, t }) => {
    const dispatch = useDispatch();
    const campaignId = match.params.id;
    const tagList = useSelector((state) => state.tagList);
    const {
        loading: tagsLoading,
        error: tagsError,
        tags: userTags,
        success: userTagSuccess,
    } = tagList;
    const [tags, setTags] = useState([]);
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const campaignDetails = useSelector((state) => state.campaignDetails);
    const { loading, campaign, error } = campaignDetails;
    const campaignUpdate = useSelector((state) => state.campaignUpdate);
    const { success } = campaignUpdate;
    const campaignDelete = useSelector((state) => state.campaignDelete);
    const { success: deleteSuccess } = campaignDelete;

    const [name, setName] = useState('');
    const [campaignNameError, setCampaignNameError] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [hasSpecificTimes, setHasSpecificTimes] = useState(false);
    const [specificTimes, setSpecificTimes] = useState([]);
    const [periodicActive, setPeriodicActive] = useState(false);
    const [isPeriodic, setIsPeriodic] = useState(false);
    const [periodicity, setPeriodicity] = useState(1);
    const [periodicityMetric, setPeriodicityMetric] = useState('hour');
    const periodicityMetricOptions = [
        { label: t('campaign_hour'), value: 'hour' },
        { label: t('campaign_day'), value: 'day' },
    ];

    const [validFrom, setValidFrom] = useState('');
    const [validTo, setValidTo] = useState('');
    const [validationError, setValidationError] = useState(null);
    const [isEnabled, setIsEnabled] = useState(true);

    const commercials = useSelector((state) => state.commercialList);
    const {
        loading: commercialsLoading,
        commercialList,
        error: signalError,
    } = commercials;
    const [commercialOptions, setCommercialOptions] = useState();
    const [selectedCommercials, setSelectedCommercials] = useState([]);

    const signals = useSelector((state) => state.signalList);
    const { loading: signalsLoading, signalList, signalsError } = signals;
    const [signalOptions, setSignalOptions] = useState();
    const [selectedStartingSignal, setSelectedStartingSignal] = useState(null);
    const [selectedEndingSignal, setSelectedEndingSignal] = useState(null);

    const announcements = useSelector((state) => state.announcementList);
    const {
        loading: announcementsLoading,
        announcementList,
        error: announcementError,
    } = announcements;
    const [announcementOptions, setAnnouncementOptions] = useState();
    const [selectedAnnouncements, setSelectedAnnouncements] = useState([]);
    const [description, setDescription] = useState('');
    const [playerTagsOptions, setPlayerTagsOptions] = useState([]);
    const [selectedPlayerTags, setSelectedPlayerTags] = useState([]);
    const [selectedCommercialTags, setSelectedCommercialTags] = useState([]);
    const [commercialTagsOptions, setCommercialTagsOptions] = useState([]);

    const [blockDuration, setBlockDuration] = useState(0);

    const playersList = useSelector((state) => state.playerList);
    const {
        loading: playersLoading,
        players: playerList,
        error: playersError,
    } = playersList;
    const [playerOptions, setPlayerOptions] = useState([]);
    const [selectedPlayers, setSelectedPlayers] = useState([]);

    const onSelectedCommercialTagsChange = (commercialTagsFromSelect) => {
        setSelectedCommercialTags(commercialTagsFromSelect);
        let tagNames = commercialTagsFromSelect.map((e) => e.name);

        //console.log(tagNames);
        let commercialsSelected = selectedCommercials.slice();

        if(tagNames.length > 0) {
            commercialOptions.forEach((element) => {
                if (element.tags.filter(e => tagNames.includes(e.name)).length > 0 && commercialsSelected.filter(e => e._id === element._id).length === 0) {
                    commercialsSelected.push(element);
                }
                else if(element.tags.filter(e => tagNames.includes(e.name)).length === 0 && commercialsSelected.filter(e => e._id === element._id).length !== 0){
                    let idx;
                    let exists = commercialsSelected.some((item, index) => {
                        idx = index;
                        return item._id === element._id;
                    });
                    if(exists){
                        commercialsSelected.splice(idx, 1);
                    }
                }
            });

            setSelectedCommercials(commercialsSelected);
        }
        else {
            setSelectedCommercials([]);
        }

    };

    const onSelectedPlayerTagsChange = (playerTagsFromSelect) => {
        setSelectedPlayerTags(playerTagsFromSelect);
        let tagNames = playerTagsFromSelect.map((e) => e.name);
        //console.log(tagNames);
        let playersSelected = selectedPlayers.slice();

        if(tagNames.length > 0) {
            playerOptions.forEach((element) => {
                if (element.tags.filter(e => tagNames.includes(e.name)).length > 0 && playersSelected.filter(e => e.folder === element.folder).length === 0) {
                    playersSelected.push(element);
                }
                else if(element.tags.filter(e => tagNames.includes(e.name)).length === 0 && playersSelected.filter(e => e.folder === element.folder).length !== 0){
                    let idx;
                    let exists = playersSelected.some((item, index) => {
                        idx = index;
                        return item.folder === element.folder;
                    });
                    if(exists){
                        playersSelected.splice(idx, 1);
                    }
                    //playersSelected.splice(playersSelected.findIndex(element), 1);
                }
            });

            setSelectedPlayers(playersSelected);
        }
        else {
            console.log('empty tag names');
            setSelectedPlayers([]);
        }

        //console.log(Array.from(playersSelected));
    };

    const onSelectedCommercialsChange = (commercialsFromSelect) => {
        setSelectedCommercials(commercialsFromSelect);
        calculateDuration();
    };

    const onSelectedStartingSignalChange = (signalFromSelect) => {
        setSelectedStartingSignal(signalFromSelect);
        calculateDuration();
    };

    const onSelectedEndingSignalChange = (signalFromSelect) => {
        setSelectedEndingSignal(signalFromSelect);
    };

    useEffect(() => {
        calculateDuration();
    }, [selectedEndingSignal, selectedAnnouncements, selectedStartingSignal, selectedCommercials])

    const onSelectedAnnouncementsChange = (announcementsFromSelect) => {
        setSelectedAnnouncements(announcementsFromSelect);
        calculateDuration();
    };

    const onSelectedPeriodicityMetricChange = (periodicityMetricFromSelect) => {
        setPeriodicActive(true);
        setPeriodicityMetric(periodicityMetricFromSelect.value);
    };

    const onSelectedPlayersChange = (playersFromSelect) => {
        setSelectedPlayers(playersFromSelect);
    };

    useEffect(() => {
        dispatch({type: CAMPAIGN_UPDATE_DETAILS_RESET});
    }, []);

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(() => {
        if (
            !campaign ||
            !campaign.name ||
            success ||
            campaign._id !== campaignId
        ) {
            dispatch({ type: CAMPAIGN_UPDATE_DETAILS_RESET });
            dispatch(listCampaignDetails(match.params.id));
        } else {
            setIsPeriodic(campaign.isPeriodic);
            setPeriodicity(campaign.periodicity);
            setPeriodicityMetric(campaign.periodicityMetric);
            setHasSpecificTimes(campaign.hasSpecificTimes);
            setSpecificTimes(campaign.specificTimes);
            if (campaign.startingSignal) {
                setSelectedStartingSignal({
                    ...campaign.sartingSignal,
                    label: campaign.startingSignal.name,
                    value: campaign.startingSignal._id,
                });
            }
            if (campaign.endingSignal) {
                setSelectedEndingSignal({
                    ...campaign.endingSignal,
                    label: campaign.endingSignal.name,
                    value: campaign.endingSignal._id,
                });
            }
            if (campaign.announcements) {
                setSelectedAnnouncements(() =>
                    campaign.announcements.map((announcement) => {
                        announcement.label = announcement.name;
                        announcement.value = announcement._id;
                        return announcement;
                    })
                );
            }
            if (campaign.commercials) {
                setSelectedCommercials(() =>
                    campaign.commercials.map((commercial) => {
                        //console.log(commercial.name);
                        commercial.label = commercial.name;
                        commercial.value = commercial._id;
                        return commercial;
                    })
                );
            }

            calculateDuration();

            if (campaign.players) {
                setSelectedPlayers(() =>
                    campaign.players.map((player) => {
                        player.label = player.name;
                        player.value = player._id;
                        return player;
                    })
                );
            }
            setValidTo(campaign.validTo);
            setValidFrom(campaign.validFrom);
            setDescription(campaign.description);
            setName(campaign.name);

            if(campaign.tags){
                setTags(() =>
                    campaign.tags.map((tgs) => {
                        tgs.label = tgs.name;
                        tgs.value = tgs._id;
                        return tgs;
                    })
                );
            }
            //setTags(campaign.tags);
            setIsEnabled(campaign.isEnabled);
            setPeriodicActive(campaign.isPeriodic);
        }
    }, [dispatch, match, campaign, campaignId]);

    useEffect(() => {
        if (!userTagSuccess || success) {
            dispatch(listTags());
        } else {
            setSuggestions(() =>
                userTags.map((tgs) => {
                    tgs.label = tgs.name;
                    tgs.value = tgs._id;
                    return tgs;
                })
            );
            //setSuggestions(userTags);
        }
    }, [userTagSuccess, dispatch]);

    const deleteCampaignHandle = async () => {
        dispatch(deleteCampaign(campaign._id));
    };

    useEffect(() => {
        dispatch(listMedia('commercials'));
        dispatch(listMedia('announcements'));
        dispatch(listMedia('signals'));
        dispatch(listPlayers());
    }, [dispatch]);

    useEffect(() => {
        if (deleteSuccess) {
            history.push('/campaigns');
            dispatch({ type: CAMPAIGN_DELETE_RESET });
        } else {
            dispatch({ type: CAMPAIGN_DELETE_RESET });
        }
    }, [deleteSuccess, dispatch, history]);

    useEffect(() => {
        if (playerList) {
            const moddedList = playerList.map((element) => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            setPlayerOptions(moddedList);

            const moddedTagList = [];
            playerList.forEach((element) => {
                let insideTags = element.tags;
                //console.log(insideTags);
                insideTags.forEach(tag => {
                    tag.label = tag.name;
                    tag.value = tag._id;
                    if(!moddedTagList.some((item,index) => {
                        return item.name === tag.name;
                    })) {
                        moddedTagList.push(tag);
                    }
                });
            });
            setPlayerTagsOptions(moddedTagList);
        }
    }, [playerList]);

    useEffect(() => {
        if (!commercialsLoading && commercialList != null) {
            let idk = commercialList.map((commercial) => {
                commercial.label = commercial.name;
                commercial.value = commercial._id;
                return commercial;
            });
            setCommercialOptions(idk);

            const moddedTagList = [];
            idk.forEach((element) => {
                let insideTags = element.tags;
                //console.log(insideTags);
                insideTags.forEach(tag => {
                    tag.label = tag.name;
                    tag.value = tag._id;
                    if(!moddedTagList.some((item,index) => {
                        return item.name === tag.name;
                    })) {
                        moddedTagList.push(tag);
                    }
                });
            });
            setCommercialTagsOptions(moddedTagList);
        }
    }, [commercialsLoading, commercialList]);

    useEffect(() => {
        if (!signalsLoading && signalList != null) {
            let idk = signalList.map((signal) => {
                signal.label = signal.name;
                signal.value = signal._id;
                return signal;
            });
            setSignalOptions(idk);
        }
    }, [signalsLoading, signalList]);

    useEffect(() => {
        if (!announcementsLoading && announcementList != null) {
            let idk = announcementList.map((announcement) => {
                announcement.label = announcement.name;
                announcement.value = announcement._id;
                return announcement;
            });
            setAnnouncementOptions(idk);
        }
    }, [signalsLoading, signalList]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }
        if(campaignNameError !== ''){
            return;
        }
        if (e.key === 'Enter') {
            return;
        }

        let label,value
        let startingSignal = null;
        if (selectedStartingSignal) {
            ({
                label,
                value,
                ...startingSignal
            } = selectedStartingSignal);
        }

        let endingSignal = null;
        if (selectedEndingSignal) {
            ({
                label,
                value,
                ...endingSignal
            } = selectedEndingSignal);
        }

        let announcements = [];
        if (selectedAnnouncements) {
            announcements = selectedAnnouncements.map(element => {
                let {label,value, ...rest} = element;
                return rest;
            });
        }

        let commercials = [];
        if (selectedCommercials) {
            commercials = selectedCommercials.map(element => {
                let {label,value, ...rest} = element;
                return rest;
            });
        }

        let players = [];
        if (selectedPlayers) {
            players = selectedPlayers.map(element => {
                let {label,value, ...rest} = element;
                return rest;
            });
        }

        const campaign = {
            isPeriodic: periodicActive,
            periodicity: periodicity,
            periodicityMetric: periodicityMetric,
            hasSpecificTimes: specificTimes.length > 0,
            specificTimes: specificTimes,
            startingSignal: startingSignal,
            endingSignal: endingSignal,
            announcements: announcements,
            commercials: commercials,
            validFrom: validFrom,
            validTo: validTo,
            description: description,
            name: name,
            tags: tags,
            isEnabled: isEnabled,
            players: players,
        };
        //console.log(campaign);
        dispatch(updateCampaign(campaignId, campaign));
    };

    // TODO: remove px styles
    const validate = () => {
        setValidationError(null);
        let errors = '';
        /*if (!periodicActive && !hasSpecificTimes) {
            errors += t('campaign_validation_error_periodic_or_specific');
        }*/
        /*if (hasSpecificTimes && specificTimes.length === 0) {
            errors += t('campaign_validation_error_missing_specific');
        }*/
        if (
            hasSpecificTimes &&
            specificTimes.length > 0 &&
            new Set(specificTimes).size !== specificTimes.length
        ) {
            errors += t('campaign_validation_error_multiple_starting');
        }
        if (
            selectedAnnouncements.length === 0 &&
            selectedCommercials.length === 0
        ) {
            errors += t('campaign_validation_error_no_real_content');
        }
        if (validFrom === '' || validTo === '') {
            errors += t('campaign_validation_error_missing_period');
        }

        if (errors !== '') {
            setValidationError(errors);
            return false;
        } else {
            return true;
        }
    };

    const add = () => {
        setSpecificTimes((previousHours) => {
            const idk = [...previousHours];
            idk[idk.length] = '08:00';
            return idk;
        });
    };

    const calculateDuration = () => {
        try {
            const startingSignalDuration = Number(((selectedStartingSignal !== null) ? selectedStartingSignal.duration.toFixed(2) : 0));
            const endingSignalDuration = Number((selectedEndingSignal !== null ? selectedEndingSignal.duration.toFixed(2) : 0));
            const announcementDuration = (selectedAnnouncements.length !== 0 ? selectedAnnouncements.map((e) => Number(e.duration.toFixed(2))) : [0]).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
            const commercialDuration = (selectedCommercials.length !== 0 ? selectedCommercials.map((e) => Number(e.duration.toFixed(2))) : [0]).reduce((previousValue, currentValue) => previousValue + currentValue, 0);

            setBlockDuration(startingSignalDuration + endingSignalDuration + announcementDuration + commercialDuration);
        }
        catch (e) {
            console.log(e.toString());
        }
    }

    return (
        <>
            <Container>
                {success && (
                    <Message variant='success'>{t('campaign_refreshed')}</Message>
                )}

                <ThreeColumnRow firstColumn={<Link to='/campaigns' className='btn btn-info m-0 p-2'>
                    {t('button_back')}
                </Link>} secondColumn={t('campaign_data')} thirdColumn={<div
                    className='btn btn-danger m-0 p-2'
                    onClick={() => deleteCampaignHandle()}
                >
                    {t('button_delete')}
                </div>}/>

                <Form autoComplete='off' onSubmit={handleSubmit}>
                    <Row>
                        <Col lg>
                            <Row className='ml-0 mr-0 mb-2'>
                                <Button
                                    style={{ width: '100%' }}
                                    variant='outline-info'
                                    onClick={() => setIsPeriodic(!isPeriodic)}
                                    aria-controls='collapsable-period-menu'
                                    aria-expanded={isPeriodic}
                                >
                                    {t('campaign_set_periodic')}
                                </Button>
                                <Collapse in={isPeriodic}>
                                    <div id='collapsable-period-menu'>
                                        <Form.Group className='mt-3'>
                                            <Form.Row className='ml-0 mr-0'>
                                                <Row>
                                                    <Col className='ml-2 mt-auto mr-auto mb-auto'>
                                                        <input
                                                            type='number'
                                                            autoComplete='off'
                                                            min={1}
                                                            onChange={(e) => {
                                                                if (
                                                                    e.target
                                                                        .valueAsNumber <
                                                                    1
                                                                ) {
                                                                    e.target.setCustomValidity(
                                                                        'Biztos?'
                                                                    );
                                                                } else {
                                                                    e.target.setCustomValidity(
                                                                        ''
                                                                    );
                                                                    setPeriodicActive(
                                                                        true
                                                                    );
                                                                    setPeriodicity(
                                                                        e.target
                                                                            .valueAsNumber
                                                                    );
                                                                }
                                                            }}
                                                            value={periodicity}
                                                        />
                                                    </Col>
                                                    <Col
                                                        sm={1}
                                                        className='ml-auto mt-auto mr-auto mb-auto'
                                                    >
                                                        <label>{t('campaign_per')}</label>
                                                    </Col>
                                                    <Col className='ml-auto mt-auto mr-auto mb-auto'>
                                                        <div
                                                            className='ml-2'
                                                            style={{
                                                                minWidth:
                                                                    '80px',
                                                            }}
                                                        >
                                                            <Select
                                                                options={
                                                                    periodicityMetricOptions
                                                                }
                                                                value={periodicityMetricOptions.filter(
                                                                    (el) => {
                                                                        return (
                                                                            el.value ===
                                                                            periodicityMetric
                                                                        );
                                                                    }
                                                                )}
                                                                onChange={
                                                                    onSelectedPeriodicityMetricChange
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col className='ml-auto mt-auto mr-2 mb-auto'>
                                                        <div
                                                            className='ml-2'
                                                            style={{
                                                                minWidth:
                                                                    '90px',
                                                            }}
                                                        >
                                                            {periodicActive ? (
                                                                <Button
                                                                    variant='success'
                                                                    onClick={() =>
                                                                        setPeriodicActive(
                                                                            !periodicActive
                                                                        )
                                                                    }
                                                                    style={{
                                                                        width:
                                                                            '100px',
                                                                    }}
                                                                >
                                                                    {t('button_active')}
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant='danger'
                                                                    onClick={() =>
                                                                        setPeriodicActive(
                                                                            !periodicActive
                                                                        )
                                                                    }
                                                                    style={{
                                                                        width:
                                                                            '100px',
                                                                    }}
                                                                >
                                                                    {t('button_inactive')}
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form.Row>
                                        </Form.Group>
                                    </div>
                                </Collapse>
                            </Row>
                        </Col>
                        <Col lg>
                            <Row className='ml-0 mr-0 mb-2'>
                                <Button
                                    style={{ width: '100%' }}
                                    block
                                    variant='outline-info'
                                    onClick={() => {
                                        setHasSpecificTimes(!hasSpecificTimes);
                                    }}
                                    aria-controls='collapsable-constant-menu'
                                    aria-expanded={hasSpecificTimes}
                                >
                                    {t('campaign_set_specific')}
                                </Button>
                                <Collapse in={hasSpecificTimes}>
                                    <div
                                        id='collapsable-constant-menu'
                                        style={{ width: '100%' }}
                                    >
                                        <Form.Group className='mt-2'>
                                            {specificTimes.map(
                                                (time, index) => {
                                                    return (
                                                        <Row
                                                            className='mr-0 ml-0 mb-2'
                                                            key={index}
                                                        >
                                                            <input
                                                                key={index}
                                                                type='time'
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    //setOpenHoursFrom(e.target.value);
                                                                    setSpecificTimes(
                                                                        (
                                                                            previousHours
                                                                        ) => {
                                                                            const idk = [
                                                                                ...previousHours,
                                                                            ];
                                                                            idk[
                                                                                index
                                                                            ] =
                                                                                e.target.value;

                                                                            return idk;
                                                                        }
                                                                    );
                                                                }}
                                                                value={
                                                                    specificTimes[
                                                                        index
                                                                    ]
                                                                }
                                                            />
                                                            <Button
                                                                onClick={() => {
                                                                    setSpecificTimes(
                                                                        (
                                                                            previousHours
                                                                        ) => {
                                                                            const idk = [
                                                                                ...previousHours,
                                                                            ];
                                                                            idk.splice(
                                                                                index,
                                                                                1
                                                                            );
                                                                            return idk;
                                                                        }
                                                                    );
                                                                }}
                                                                variant='outline-danger'
                                                                size='sm'
                                                                className='ml-2'
                                                            >
                                                                X
                                                            </Button>
                                                        </Row>
                                                    );
                                                }
                                            )}
                                        </Form.Group>
                                        <div className='justify-content-md-center row'>
                                            <Button
                                                onClick={add}
                                                variant='outline-info'
                                                size='sm'
                                                className='m-auto'
                                            >
                                                {t('campaign_add_specific_time')}
                                            </Button>
                                        </div>
                                    </div>
                                </Collapse>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg>
                            <Form.Group controlId='campaignName'>
                                <Form.Label>{t('campaign_name')}</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={(t('campaign_name'))}
                                    required
                                    value={name}
                                    onChange={(event) => {
                                        if(event.target.value.includes(',')){
                                            setCampaignNameError(t('campaign_name_error'));
                                        }
                                        else {
                                            setCampaignNameError('');
                                        }
                                        setName(event.target.value);
                                    }}
                                    isInvalid={name.includes(',')}
                                />
                                <Form.Control.Feedback type='invalid'>{campaignNameError}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{t('campaign_period')}</Form.Label>
                                <Form.Row className='ml-0 mr-0 mt-2'>
                                    <input
                                        type='date'
                                        onChange={(e) => {
                                            setValidFrom(e.target.value);
                                        }}
                                        value={validFrom}
                                    />
                                    <label className='ml-2 mt-auto mr-auto mb-auto'>
                                        -
                                    </label>
                                    <Col>
                                        <input
                                            type='date'
                                            className=''
                                            onChange={(e) => {
                                                setValidTo(e.target.value);
                                            }}
                                            value={validTo}
                                        />
                                    </Col>
                                </Form.Row>
                            </Form.Group>
                            <Form.Group controlId='startingSignalName'>
                                <Form.Label>{t('campaign_starting_signal')}</Form.Label>
                                <Select
                                    options={signalOptions}
                                    name='Starting Signal'
                                    isClearable
                                    isSearchable
                                    onChange={onSelectedStartingSignalChange}
                                    className='react-select-container'
                                    classNamePrefix='react-select'
                                    placeholder={t('campaign_starting_signal_description')}
                                    value={
                                        selectedStartingSignal
                                            ? selectedStartingSignal
                                            : ''
                                    }
                                />
                            </Form.Group>
                            <Form.Group controlId='endingSignalName'>
                                <Form.Label>{t('campaign_ending_signal')}</Form.Label>
                                <Select
                                    options={signalOptions}
                                    name='Ending Signal'
                                    isClearable
                                    isSearchable
                                    onChange={onSelectedEndingSignalChange}
                                    className='react-select-container'
                                    classNamePrefix='react-select'
                                    placeholder={t('campaign_ending_signal_description')}
                                    value={
                                        selectedEndingSignal
                                            ? selectedEndingSignal
                                            : ''
                                    }
                                />
                            </Form.Group>
                            <Form.Group controlId='announcementsName'>
                                <Form.Label>{t('campaign_announcements')}</Form.Label>
                                <Select
                                    options={announcementOptions}
                                    isMulti
                                    name='Announcements'
                                    isClearable
                                    isSearchable
                                    onChange={onSelectedAnnouncementsChange}
                                    className='react-select-container'
                                    classNamePrefix='react-select'
                                    placeholder={t('campaign_announcements_description')}
                                    value={
                                        selectedAnnouncements
                                            ? selectedAnnouncements
                                            : ''
                                    }
                                />
                            </Form.Group>
                            {tagsLoading ? (
                                <Loader />
                            ) : (
                                <Form.Group controlId='tags'>
                                    <Form.Label>{t('campaign_tags')}</Form.Label>
                                    <CreatableSelect
                                         isMulti
                                         isSearchable
                                         isClearable
                                         formatCreateLabel= {(inputValue) => `${t('create_tag')}: "${inputValue}"`}
                                         onChange={(newTag) => {
                                             const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                             if(temporaryTag !== null && temporaryTag !== undefined){
                                                 newTag = temporaryTag;
                                             }
                                             //console.log(newTag);
                                             setTags(newTag);
                                         }}
                                         onCreateOption={(newTag) => {
                                             const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                             if(temporaryTag !== null && temporaryTag !== undefined){
                                                 newTag = temporaryTag;
                                             }
                                             else {
                                                 newTag = {
                                                     id: undefined,
                                                     label: newTag,
                                                     value: newTag,
                                                     name: newTag
                                                 }
                                             }
                                             //console.log(newTag);
                                             setTags([...tags, newTag]);
                                         }}
                                         options={suggestions}
                                         value={tags}
                                         placeholder={t('campaign_tags_description')}
                                         className='react-select-container'
                                         classNamePrefix='react-select'
                                    />
                                    {/*<ReactTags
                                        allowNew={true}
                                        placeholderText={t('campaign_tags_description')}
                                        allowBackspace={false}
                                        onDelete={(idx) => {
                                            const newTags = tags.slice(0);
                                            newTags.splice(idx, 1);
                                            setTags(newTags);
                                        }}
                                        onAddition={(newTag) => {
                                            console.log(newTag);
                                            const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                            if(temporaryTag !== null && temporaryTag !== undefined){
                                                newTag = temporaryTag;
                                            }
                                            //console.log(newTag);
                                            setTags([...tags, newTag]);
                                        }}
                                        suggestions={suggestions}
                                        tags={tags}
                                    />*/}
                                </Form.Group>
                            )}
                            {validationError ? (
                                <Message variant='danger'>
                                    {validationError}
                                </Message>
                            ) : null}
                            {loading ? <Loader /> : null}
                            {error ? (
                                <Message variant='danger'>{error}</Message>
                            ) : null}
                        </Col>
                        <Col lg>
                            <Form.Group controlId='commercialsByTagsName'>
                                <Form.Label>{t('campaign_select_commercials_by_tags')}</Form.Label>
                                <MultiSelect
                                    options={commercialTagsOptions}
                                    value={selectedCommercialTags}
                                    onChange={onSelectedCommercialTagsChange}
                                    placeholder={t('campaign_select_commercials_by_tags')}
                                />
                            </Form.Group>
                            <Form.Group controlId='Reklámok'>
                                <Form.Label>{t('campaign_commercials')}</Form.Label>
                                <Select
                                    options={commercialOptions}
                                    isMulti
                                    name='Commercials'
                                    isClearable
                                    isSearchable
                                    onChange={onSelectedCommercialsChange}
                                    className='react-select-container'
                                    classNamePrefix='react-select'
                                    placeholder={t('campaign_commercials_description')}
                                    value={
                                        selectedCommercials
                                            ? selectedCommercials
                                            : ''
                                    }
                                />
                            </Form.Group>
                            <Form.Group controlId='playersByTagsName'>
                                <Form.Label>{t('campaign_select_players_by_tags')}</Form.Label>
                                <MultiSelect
                                    options={playerTagsOptions}
                                    value={selectedPlayerTags}
                                    onChange={onSelectedPlayerTagsChange}
                                    placeholder={t('campaign_select_players_by_tags')}
                                />
                            </Form.Group>
                            <Form.Group controlId='playersName'>
                                <Form.Label>{t('campaign_players')}</Form.Label>
                                <MultiSelect
                                    options={playerOptions}
                                    value={selectedPlayers}
                                    onChange={onSelectedPlayersChange}
                                    placeholder={t('campaign_players_description')}
                                />
                            </Form.Group>
                            <Form.Group controlId='campaignDescription'>
                                <Form.Label>{t('campaign_description')}</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={t('campaign_description_description')}
                                    value={description ? description : ''}
                                    onChange={(event) => {
                                        setDescription(event.target.value);
                                    }}
                                />
                            </Form.Group>
                            <Form.Group controlId='campaignIsEnabled'>
                                <Form.Label>{t('campaign_isEnabled')}</Form.Label>

                                <div className="custom-control custom-switch custom-switch-md">
                                    <input checked={isEnabled} type="checkbox" className="custom-control-input" id="customSwitch7" onChange={(event) => {
                                        setIsEnabled(event.target.checked);
                                    }}/>
                                        <label className="custom-control-label" htmlFor="customSwitch7">{isEnabled ? t('campaign_active') : t('campaign_inactive')}</label>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                    {
                        campaign !== null && campaign !== undefined ? <div className={'text-center text-primary pb-2'}>
                            {t('campaign_approximate_duration')}

                            {blockDuration}{" "}
                            {t('media_duration_unit')}
                        </div> : <div></div>
                    }

                    <Button
                        type='submit'
                        variant='success'
                        className='d-block mx-auto mt-2'
                    >
                        {t('button_save')}
                    </Button>
                </Form>
            </Container>
        </>
    );
};

export default CampaignScreen;
